import styled from 'styled-components'

export const Field = styled.div`
  width: 16rem;

  & > label {
    height: 2rem;
  }

  & > input, select {
    height: 2.5rem;
  }
`

export const Form = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.4rem;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
`

export const Submit = styled.input`
  margin-top: 2rem;
  width: 16rem;
  height: 2.5rem;
`
